import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader } from "@/components/common";

export default function InfosPage() {
  const [cols, setCols] = useState(null);
  useEffect(() => { api.get("/footer/columns").then((r) => setCols(r.data)).catch(() => setCols([])); }, []);
  if (!cols) return <Loader />;
  return (
    <div className="max-w-3xl mx-auto py-6" data-testid="infos-page">
      <h1 className="font-display text-2xl font-extrabold text-[#0F172A] mb-6">Informations & Aide</h1>
      <div className="space-y-6">
        {cols.map((c) => (
          <section key={c.id} data-testid={`infos-col-${c.key}`}>
            <h2 className="text-xs font-bold tracking-wider text-slate-500 mb-2">{c.label}</h2>
            <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100">
              {(c.links || []).map((l) => (
                <Link key={l.slug} to={l.href || `/pages/${l.slug}`} className="block px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 active:bg-slate-100" data-testid={`infos-link-${l.slug}`}>{l.title}</Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
